import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { RootState } from './types';
import { profile } from '@/store/profile';
import { asset } from '@/store/asset';
import { sellOffer } from '@/store/sellOffer';
import { wallet } from '@/store/wallet';
import { appState } from '@/store/appState';
import { stepper } from '@/store/stepper';

Vue.use(Vuex);

/**
 * Vuex and Typescript pattern
 * @see https://codeburst.io/vuex-and-typescript-3427ba78cfa8
 */
const store: StoreOptions<RootState> = {
  state: {
    version: '1.0.0', // a simple property
  },
  modules: {
    appState,
    profile,
    asset,
    sellOffer,
    wallet,
    stepper,
  },
};

export default new Vuex.Store<RootState>(store);
